import config from '_config';

function generateGridText(table, rows, columns, options = {}) {
  const {
    emptyChar = ' ',
    separator = '',
    // Hunting words: positionx=row, positiony=col
    // Letrex / crossword-like: positionx=col, positiony=row
    rowKey = 'positionx',
    colKey = 'positiony',
  } = options;

  const grid = Array.from({ length: rows }, () => Array(columns).fill(emptyChar));

  if (!Array.isArray(table)) {
    return grid.map(row => row.join(separator)).join('\r\n');
  }

  table.forEach(cell => {
    const row = Number(cell[rowKey]);
    const col = Number(cell[colKey]);

    const rowIsInvalid = Number.isNaN(row) || row < 0 || row >= rows;
    const colIsInvalid = Number.isNaN(col) || col < 0 || col >= columns;

    if (rowIsInvalid || colIsInvalid) {
      return;
    }

    const char = cell.text
      ? cell.text.charAt(0).toLocaleUpperCase(config.LOCALE)
      : emptyChar;
    grid[row][col] = char;
  });

  return grid.map(row => row.join(separator)).join('\r\n');
}

export default generateGridText;
